import React from "react";
import PropTypes from "prop-types";

import { AppContext } from "components";
import { BaseComponent } from "shared/components";

// import ProductCreateContainer from "./ProductCreateContainer";
import TabletProductCreateContainer from "./TabletProductCreateContainer";


class ProductCreateContainerView extends BaseComponent {

    render() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return <TabletProductCreateContainer />
        }

        // return <ProductCreateContainer />
        return <TabletProductCreateContainer />
    }
}

ProductCreateContainerView.contextType = AppContext;

ProductCreateContainerView.propTypes = {
    history: PropTypes.object
};

export default ProductCreateContainerView;
